
editAdBoxController.$inject = ['$scope', '$mdDialog', 'controllerParams'];
export function editAdBoxController($scope, $mdDialog, controllerParams) {


  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.addAdId = addAdId;
  $scope.removeAdId = removeAdId;

  init();

  function ok() {
    $mdDialog.hide({
      entrypointDescription: $scope.model.entrypointDescription,
      adId: $scope.model.adId,
      newAdIds: $scope.model.adIds
    });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function addAdId() {
    $scope.model.adIds.push('');
  }

  function removeAdId(index) {
    $scope.model.adIds.splice(index, 1);
  }

  function init() {
    $scope.model = {
      entrypointDescription: controllerParams.entrypointDescription,
      adId: controllerParams.adId,
      adIds: controllerParams.currentAdIds,
    };
    $scope.adIdRegexp = /^[0-9]*$/;
    $scope.canHaveOneAdId = controllerParams.canHaveOneAdId;
    $scope.canHaveAdIds = controllerParams.canHaveAdIds;
  }

}
